<app-configuration-page
  title="QuickBooks"
  description="Connect your Intuit company, map the accounts records post to, then sync."
  [breadcrumbs]="[{ label: 'Integrations' }, { label: 'QuickBooks' }]">

  <div class="row">
    <!-- Main column: settings -->
    <div class="col-lg-8 col-12 quickbooks-main-col">
      <app-form-quickbooks-settings></app-form-quickbooks-settings>
    </div>

    <!-- Sidebar: setup guide -->
    <div class="col-lg-4 col-12">
      <app-setup-guide
        heading="Connecting your company"
        [steps]="setupSteps">
      </app-setup-guide>
    </div>
  </div>

</app-configuration-page>
